import React from "react";
import ErrorPage from "../pages/ErrorPage";
import {mapStackTrace} from "sourcemapped-stacktrace";
import { useDebounce } from "../hooks/useDebounce";
import Analytics from "../lib/Analytics";
import { forceReload } from "../lib/reload";

const isChunkLoadError = (error) => {
  const msg = error?.message || "";
  return msg.includes("Failed to fetch dynamically imported module") ||
         msg.includes("Loading chunk") ||
         msg.includes("Importing a module script failed");
};

// NOTE: there is no "componentDidCatch" equivalent for functional components
class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null, stackTrace: null, mappedStackTrace: null };
  }

  componentDidCatch(error, errorInfo) {
    const stackTrace = error?.stack || errorInfo?.componentStack || "";
    this.setState({
      error: error,
      errorInfo: errorInfo,
      stackTrace
    }, () => {
      mapStackTrace(stackTrace, mappedStackTrace => {
        this.setState({ mappedStackTrace });
      })
    });
    if (!isChunkLoadError(error)) {
      try {
        Analytics.exception(error, false);
      } catch (_) {}
    }
  }

  render() {
    const {error, stackTrace, mappedStackTrace} = this.state;
    if (error) {
      if (isChunkLoadError(error)) {
        return (
          <div className="app-container error-page">
            <div className="error-content">
              <span>A new version of the app is available.</span>
              <br />
              <a href="/" onClick={(e) => { e.preventDefault(); forceReload(); }}>
                Reload to continue
              </a>
            </div>
          </div>
        );
      }
      return (
        <div>
          <ErrorPage
            error={error}
            stackTrace={mappedStackTrace || stackTrace}
          />
        </div>
      );
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;
